import TimeAndDistance from './TimeAndDistance';

export default TimeAndDistance;
